import { connect } from 'react-redux';
import { changeNumberOfPartnerSFTPRequests } from '../actions';

import PartnerSFTPTransfersBrick from '../components/PartnerSFTPTransfersBrick';

const TRANSFERS_RESULTS_BASE_URL = '/transfers/partnerSftp/page';

const mapStateToProps = (state) => {
  const {
    versionData: {
      client: { clientName, clientGUID },
    },
    partnerSftpTransfersBrick: { numberOfTransfers },
  } = state;
  return {
    numberOfTransfers,
    createLookupTransfersButtonUrl: (environmentName) =>
      `${TRANSFERS_RESULTS_BASE_URL}/${clientName}/${clientGUID}/${numberOfTransfers}/${environmentName}`,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeNumberOfRequests: (event) => {
      if (event && event.target) {
        dispatch(changeNumberOfPartnerSFTPRequests(event.target.value));
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerSFTPTransfersBrick);
